import { FormattedMessage } from 'react-intl'
import BodyText from 'LuxKit/Typography/BodyText'
import TextLink from 'LuxKit/TextLink'
import FormatCurrency from 'components/Common/FormatCurrency'
import { useAppSelector } from 'hooks/reduxHooks'
import { getBaseTierOfferWithJoiningFee } from 'selectors/luxPlusSelectors'
import { getCanRedeemLuxPlusBenefits } from 'luxPlus/selectors/featureToggle'
import { LUXURY_PLUS_PATHS } from 'luxPlus/constants/base'

// The joining fee waiver disclaimer only applies to visitors who can still purchase LuxPlus+ (not
// already members) — but the savings disclaimer is evergreen and always shown on this page,
// since it also backs the "$X each year*" claim in the hero's savings badge.
function LuxPlusMonthTakeoverFinePrint() {
  const offer = useAppSelector(getBaseTierOfferWithJoiningFee)
  const canRedeemLuxPlusBenefits = useAppSelector(getCanRedeemLuxPlusBenefits)

  return (
    <BodyText variant="small">
      {offer && !canRedeemLuxPlusBenefits && <div>
        <FormattedMessage
          id="uz_eTEsV2QcugTAod98D"
          defaultMessage="^Joining fee currently waived when purchasing with a travel offer only. {price} annual membership renews on sign-up anniversary. Cancel renewal anytime. <link>T&Cs apply.</link>"
          description="Fine print below the LuxPlus+ Month joining fee banner explaining the annual renewal terms and linking to the LuxPlus+ terms and conditions, shown only to visitors who can still join"
          values={{
            price: <FormatCurrency value={offer.price} format="roundedDollar" />,
            link: (chunks) => <TextLink size="small" weight="regular" to={`/${LUXURY_PLUS_PATHS.TERMS_AND_CONDITIONS_PAGE}`}>{chunks}</TextLink>,
          }}
        />
      </div>}
      <div>
        <FormattedMessage
          id="2Ffycma3wMHFARz-DEyO"
          defaultMessage="*Based on savings by top 10% of active LuxPlus+ members over 12 months"
          description="Footnote disclaimer about savings calculation on LuxPlus landing page"
        />
      </div>
    </BodyText>
  )
}

export default LuxPlusMonthTakeoverFinePrint
